import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use(LanguageDetector)
// pass the i18n instance to react-i18next.
.use(initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    debug: false,
    lng: 'ru', // default language - перекрывает записанное детектором языка значение
    fallbackLng: 'ru', // language to use if translations in user language are not available
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        ru: {
            translation: {
                about: {
                    title: 'О программе',
                    about: 'Кабинет каталога экспонентов.<br/>Разработан <a href="mailto:alex@molner.ru" target="_blank">Александром Федоровым</a> по заказу <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>.',
                },
                common: {
                    add: 'Добавить',
                    edit: 'Редактировать',
                    save: 'Сохранить',
                    bind: 'Привязать',
                    unbind: 'Отвязать',
                    cancel: 'Отмена',
                    error: 'Ошибка',
                    noerror: 'Ok',
                    remove: 'Удалить',
                    loading: 'Загрузка...',
                    translating: 'Переводим...',
                    translate_from_en: 'Перевести с английского',
                    translate_from_ru: 'Перевести с русского',
                    save_changes: 'Сохранить',
                    save_success: 'Изменения успешно сохранены',
                    fill_fields: 'Заполните поля ниже и нажмите кнопку "Сохранить изменения"',
                    back: 'Вернуться назад',
                },
                loader: {
                    title: 'Загрузка...',
                },
                error: {
                    error: 'Ошибка',
                    noerror: 'Готово',
                    unknown: 'Ошибка: Неизвестная ошибка',
                    api0: 'Ошибка: Нет ошибок',
                    api1: 'Ошибка: Недостаточно прав',
                    api2: 'Ошибка: Недостаточно данных',
                    api3: 'Ошибка: Некорректные данные',
                    api4: 'Ошибка: Объект уже существует',
                    api5: 'Ошибка: Объект не найден',
                    api6: 'Ошибка: Ошибка базы данных',
                    api7: 'Ошибка: Ошибка сервера',
                    http0: 'Ошибка: Ошибка сети',
                    http400: 'Ошибка: Неправильный запрос',
                    http401: 'Ошибка: Требуется авторизация',
                    http403: 'Ошибка: В доступе отказано',
                    http404: 'Ошибка: Объект не найден',
                    http413: 'Ошибка: Размер загружаемого файла слишком велик',
                    http500: 'Ошибка: Ошибка сервера',
                },
                a2e: { // admin to events
                    binds: 'Мероприятия',
                    nobinds: 'Нет привязанных мероприятий',
                    bindto: 'Доступные для привязывания',
                    nobindto: 'Нет доступных для привязывания мероприятий',
                },
                e2e: { // exhibitor to exhibitors
                    add: 'Добавить экспонента',
                    exhibitors: 'Управляемые экспоненты',
                    noexhibitors: 'Нет управляемых экспонентов',
                    show_actual: 'Показать актуальные',
                    show_archived: 'Показать архивные',
                },
                agent2event: {
                    binds: 'Мероприятия',
                    nobinds: 'Нет привязанных мероприятий',
                    bindto: 'Доступные для привязывания',
                    nobindto: 'Нет доступных для привязывания мероприятий',
                    bind_update: 'Изменить',
                    bind_new: 'Привязать',
                },
                pager: {
                    prev: 'Пред',
                    next: 'След',
                    page: 'Страница',
                    of: 'из',
                },
                logo: {
                    title: 'Логотип',
                    type: 'Формат: jpg, png',
                    size: 'Максимальный вес: 2Mb',
                    dimension: 'Рекомендуемый размер: 512x512',
                },
                file: {
                    title_add: 'Загрузка файла',
                    title_edit: 'Редактирование файла',
                    subtitle_add: 'Заполните поля ниже и выберите файл в формате PDF',
                    subtitle_edit: 'Отредактируейте поля ниже и нажмите кнопку "Сохранить изменения"',
                    name_ru: 'Название на русском языке',
                    name_en: 'Название на английском языке',
                    descr_ru: 'Описание на русском языке',
                    descr_en: 'Описание на английском языке',
                    file: 'Файл для загрузки',
                    file_hint: 'К загрузке разрешены файлы в формате PDF размером не более 3 мегабайт',
                    submit_add: 'Загрузить файл',
                    submit_edit: 'Сохранить изменения',
                    back_add: 'Вернуться без загрузки',
                    back_edit: 'Вернуться без сохранения',
                },
                user: {
                    name: 'Имя пользователя',
                    email: 'Электронная почта',
                    password: 'Пароль',
                    role: 'Тип пользователя',
                    all: 'Все',
                    root: 'Суперпользователь',
                    root_short: 'Супер',
                    admin: 'Администратор',
                    admin_short: 'Админ',
                    exhibitor: 'Компания',
                    exhibitor_short: 'Компания',
                    agent: 'Агент',
                    agent_short: 'Агент',
                },
                menu: {
                    home: 'Мои выставки',
                    archive: 'Архив выставок',
                    login: 'Войти в кабинет',
                    restore: 'Забыли пароль',
                    newpass: 'Ввести код восстановления',
                    useradd: 'Добавить пользователя',
                    userlist: 'Пользователи',
                    eventadd: 'Добавить выставку',
                    eventlist: 'Выставки',
                    exhibitoradd: 'Добавить компанию',
                    exhibitorlist: 'Экспоненты',
                    countrylist: 'Страны',
                },
                home: {
                    title: 'Добро пожаловать',
                    subtitle_root: 'Выберите с чем вы хотите работать',
                    subtitle_admin: 'Выберите выставку, с которой хотите работать',
                    subtitle_agent_1: 'Внесите максимум информации о компаниях, чтобы получить <b>на 80%-300% больше просмотров</b> в онлайн-каталоге выставки!',
                    subtitle_agent_2: 'Расскажите всем, что интересного будет происходить на стендах - <b>конвертируйте просмотры в реальных посетителей</b>!',
                    subtitle_exhibitor_1: 'Внесите максимум информации о вашей компании - <b>получите на 80%-300% больше просмотров</b> в онлайн-каталоге выставки!',
                    subtitle_exhibitor_2: 'Расскажите всем, что интересного будет происходить на вашем стенде и <b>конвертируйте просмотры в реальных посетителей</b>!',
                    users: 'Пользователи',
                    events: 'Выставки',
                    exhibitors: 'Экспоненты',
                    noevents: 'Нет выставок для работы',
                    noexhibitors: 'Нет экспонентов для работы',
                    myevents: 'Мои выставки',
                    archive: 'Архив выставок',
                    agent_can_add: 'Доступное количество экспонентов для добавления: ',
                },
                header: {
                    root: 'Интерфейс суперпользователя',
                    admin: 'Интерфейс администратора',
                    agent: 'Кабинет агента',
                    exhibitor: 'Кабинет участника',
                    unknown: 'Кабинет',
                },
                login: {
                    title: 'Подключение',
                    subtitle: 'Пожалуйста, введите ваши почту и пароль',
                    email: 'Электронная почта',
                    password: 'Пароль',
                    submit: 'Подключиться',
                    restore: 'Забыли пароль',
                },
                restore: {
                    title: 'Восстановление доступа',
                    subtitle: 'Укажите адрес электронной почты, на который зарегистрирован аккаунт, и нажмите кнопку "Восстановить доступ"',
                    email: 'Электронная почта',
                    submit: 'Восстановить доступ',
                    login: 'Войти в кабинет',
                    code: 'Ввести код восстановления',
                    success: 'Проверьте, пожалуйста, вашу электронную почту. Мы отправили на нее инструкции по восстановлению доступа к кабинету.',
                },
                newpass: {
                    title: 'Создание нового пароля',
                    subtitle: 'Укажите вашу электронную почту и код из письма с инструкцией о восстановлении доступа.',
                    email: 'Электронная почта',
                    code: 'Код восстановления',
                    submit: 'Создать новый пароль',
                    login: 'Войти в кабинет',
                    success: 'Проверьте, пожалуйста, вашу электронную почту. Мы отправили на нее новый пароль для доступа в кабинет.',
                },
                logout: {
                    title: 'отключиться',
                },
                userlist: {
                    title: 'Пользователи',
                    placeholder: 'Начните вводить имя или емейл',
                    found: 'Найдено пользователей: ',
                    notfound: 'По данному запросу пользователи не найдены',
                    adduser: 'Добавить пользователя',
                },
                useradd: {
                    title_: 'Добавление пользователя',
                    title_root: 'Добавление суперпользователя',
                    title_admin: 'Добавление администратора',
                    title_exhibitor: 'Добавление компании',
                    title_agent: 'Добавление агента',
                    subtitle_: 'Заполните поля ниже',
                    subtitle_root: 'Заполните поля ниже и нажмите кнопку "Добавить суперпользователя"',
                    subtitle_admin: 'Заполните поля ниже и нажмите кнопку "Добавить администратора"',
                    subtitle_exhibitor: 'Заполните поля ниже и нажмите кнопку "Добавить компанию"',
                    subtitle_agent: 'Заполните поля ниже и нажмите кнопку "Добавить агента"',
                    name_root: 'Имя суперпользователя',
                    name_admin: 'Имя администратора',
                    name_exhibitor: 'Название компании',
                    name_agent: 'Имя агента',
                    event: 'Привязать к выставке',
                    event_hint: 'Выберите выставку из списка',
                    submit_: 'Добавить пользователя',
                    submit_root: 'Добавить суперпользователя',
                    submit_admin: 'Добавить администратора',
                    submit_exhibitor: 'Добавить компанию',
                    submit_agent: 'Добавить агента',
                    success_root: 'Суперпользователь добавлен',
                    success_admin: 'Администратор добавлен',
                    success_exhibitor: 'Компания добавлена',
                    success_agent: 'Агент добавлен',
                    password_hint: 'Сгенерировать пароль',
                    role: 'Выберите тип пользователя',
                    limit: 'Максимальное число экспонентов', 
                },
                userview: {
                    title: 'Пользователь',
                    created: 'Пользователь успешно создан',
                    updated: 'Пользователь успешно обновлен',
                    delete_confirm: 'Вы уверены что хотите удалить пользователя? Это действие необратимо!',
                    delete_success: 'Пользователь успешно удален',
                    delete_error: 'Ошибка удаления пользователя',
                    convert2agent_confirm: 'Вы уверены в том что хотите преобразовать компанию в агента?',
                    convert2exhibitor_confirm: 'Вы уверены в том что хотите преобразовать агента в компанию?',
                    convert_success: 'Преобразование пользователя прошло успешно',
                    convert_error: 'Ошибка преобразования пользователя',
                },
                useredit: {
                    title_root: 'Редактирование суперпользователя',
                    title_admin: 'Редактирование администратора',
                    title_exhibitor: 'Редактирование компании',
                    title_agent: 'Редактирование агента',
                    subtitle: 'Отредактируйте поля и нажмите кнопку "Сохранить изменения".',
                    name_root: 'Имя суперпользователя',
                    name_admin: 'Имя администратора',
                    name_exhibitor: 'Название компании',
                    name_agent: 'Имя агента',
                    email: 'Электронная почта',
                    password: 'Новый пароль',
                    password_hint: 'Если пароль менять не надо, оставьте поле пустым. Новый пароль должен быть не менее 8 символов.',
                    password_generate: 'Сгенерировать новый пароль',
                    submit: 'Сохранить изменения',
                    success: 'Пользователь успешно обновлен',
                    back: 'Вернуться без сохранения',
                },
                eventlist: {
                    title: 'Выставки',
                    placeholder: 'Начните вводить название',
                    eventadd: 'Добавить выставку',
                    found: 'Найдено выставок: ',
                    notfound: 'По данному запросу выставки не найдены',
                    actual: 'Текущие',
                    archived: 'Архивные',
                },
                eventform: {
                    title_add: 'Добавление выставки',
                    title_edit: 'Редактирование выставки',
                    subtitle_add: 'Заполните поля и нажмите кнопку "Добавить выставку"',
                    subtitle_edit: 'Заполните поля и нажмите кнопку "Сохранить изменения"',
                    submit_add: 'Добавить выставку',
                    submit_edit: 'Сохранить изменения',
                    success_add: 'Выставка добавлена',
                    success_edit: 'Изменения успешно сохранены',
                    name_ru: 'Название на русском языке',
                    name_en: 'Название на английском языке',
                    cat_main_ru: 'Название основных категорий на русском языке',
                    cat_main_en: 'Название основных категорий на английском языке',
                    cat_addon_ru: 'Название дополнительных категорий на русском языке',
                    cat_addon_en: 'Название дополнительных категорий на английском языке',
                    cat_admin_ru: 'Название специальных категорий на русском языке',
                    cat_admin_en: 'Название специальных категорий на английском языке',
                    catalog_url_ru: 'URL русской версии каталога',
                    catalog_url_en: 'URL английской версии каталога',
                    schedule_url_ru: 'URL русской версии расписания',
                    schedule_url_en: 'URL английской версии расписания',
                    back: 'Вернуться к выставке',
                    flags: 'Флаги',
                    is_files_available: 'Разрешить экспонентам загружать файлы',
                    is_archived: 'Перенести выставку в архив',
                    diplom_name_change_date: 'Дата изменения названия для документов',
                    diplom_name_change_invalid_date: 'Дата изменения названия для документов указана в некорректном формате',
                },
                eventview: {
                    title: 'Выставка',
                    created: 'Выставка успешно создана',
                    updated: 'Выставка успешно обновлена',
                    admins: 'Администраторы',
                    binds: 'Администраторы',
                    nobinds: 'У выставки нет администраторов',
                    bindto: 'Доступные для привязки',
                    nobindto: 'Нет администраторов доступных для привязки',
                    categories: 'Категории',
                    catmain: 'Основные категории:',
                    nocatmain: 'Основные категории не определены',
                    cataddon: 'Дополнительные категории:',
                    nocataddon: 'Дополнительные категории не определены',
                    catadmin: 'Специальные категории:',
                    nocatadmin: 'Специальные категории не определены',
                    export_catalog: 'Экспорт экспонентов',
                    export_events: 'Экспорт мероприятий',
                    files: 'Файлы',
                    files_available: 'Загрузка файлов экспонентами разрешена',
                    files_unavailable: 'Экспонентам не разрешено загружать файлы',
                    stickers: 'Стикеры',
                    nostickers: 'Стикеры не определены',
                    nofolder: 'Прочее',
                    counter: 'Счетчик',
                    nocounter: 'Счетчик не определен',
                    dates: 'Даты проведения',
                    nodates: 'Даты проведения не определены',
                    preset: 'Конструктор ссылки',
                    expodat: 'Экспорт в Expodat',
                },
                category: {
                    addtitle: 'Добавление категории',
                    addsubtitle: 'Категория будет добавлена для выставки ',
                    edittitle: 'Редактирование категории',
                    editsubtitle: 'Редактирование категории для выставки ',
                    name_ru: 'Название на русском языке',
                    name_en: 'Название на английском языке',
                    type: 'Тип категории',
                    folder: 'Добавить категорию в папку',
                    folder_hint: 'Выберите папку',
                    is_folder: 'Папка',
                    is_folder_label: 'Категория является папкой',
                    priority: 'Приоритет',
                    main: 'Основная',
                    addon: 'Дополнительная',
                    admin: 'Специальная',
                    admin_hint: 'Доступно для установки только администратору',
                    addsubmit: 'Добавить категорию',
                    addsuccess: 'Категория добавлена',
                    editsubmit: 'Сохранить изменения',
                    editsuccess: 'Изменения сохранены',
                    delete: 'Удалить категорию',
                    delete_confirm: 'Вы уверены что хотите удалить категорию? Это действие необратимо!',
                    back: 'Вернуться к выставке',
                },
                sticker: {
                    addtitle: 'Добавление стикера',
                    addsubtitle: 'Стикер будет добавлен для выставки ',
                    edittitle: 'Редактирование стикера',
                    editsubtitle: 'Редактирование стикера для выставки ',
                    text_ru: 'Текст на русском языке',
                    text_en: 'Текст на английском языке',
                    color: 'Цвет текста',
                    background: 'Цвет фона',
                    priority: 'Приоритет',
                    addsubmit: 'Добавить стикер',
                    addsuccess: 'Стикер добавлен',
                    editsubmit: 'Сохранить изменения',
                    editsuccess: 'Изменения сохранены',
                    delete: 'Удалить стикер',
                    delete_confirm: 'Вы уверены что хотите удалить стикер? Это действие необратимо!',
                    back: 'Вернуться к выставке',
                },
                exhibitorlist: {
                    title: 'Экспоненты',
                    placeholder: 'Начните вводить название',
                    found: 'Найдено экспонентов: ',
                    notfound: 'По данному запросу экспоненты не найдены',
                },
                exhibitoradd: {
                    title: 'Добавление экспонента',
                    subtitle1exhibitor: 'Чтобы добавить экспонента для компании ',
                    subtitle1agent: 'Чтобы добавить экспонента для агента ',
                    subtitle2: ' заполните поля ниже и нажмите "Добавить экспонента"',
                    name_ru: 'Название на русском языке',
                    name_en: 'Название на английском языке',
                    event: 'Выставка',
                    copy: 'Копировать основные поля из',
                    event_hint: 'Выберите выставку из списка',
                    exhibitor_hint: 'Выберите экспонента из списка',
                    submit: 'Добавить экспонента',
                    success: 'Экспонент добавлен',
                    baduser: 'Ошибка: Неверный идентификатор компании. Вероятно вы попали на эту страницу по неправильной ссылке.',
                    weight: 'Вес для сортировки',
                },
                exhibitorview: {
                    title: 'Экспонент',
                    created: 'Экспонент успешно создан',
                    updated: 'Информация успешно сохранена',
                    stand: 'Стенд',
                    nostand: 'Стенд не указан',
                    brand: 'Бренды',
                    nobrand: 'Бренды не указаны',
                    brief: 'Кратко о компании',
                    nobrief: 'Нет краткой информации о компании',
                    about: 'Подробно о компании',
                    noabout: 'Нет подробной информации о компании',
                    descr: 'Зачем приходить на ваш стенд',
                    nodescr: 'Нет описания содержимого стенда',
                    contacts: 'Контакты',
                    nocontacts: 'Нет информации о контактах',
                    links: 'Социальные сети',
                    nolinks: 'Ссылки не указаны',
                    stickers: 'Стикеры',
                    nostickers: 'Для заказа стикера обратитесь к вашему менеджеру проекта.',
                    stickers_tt: 'Стикер – это яркий визуальный элемент с текстом, устанавливаемый поверх карточки компании в каталоге. Он поможет выделить вашу компанию среди других участников.',
                    categories: 'Категории',
                    nocategories: 'Категории не указаны',
                    diplomname: 'Имя для диплома',
                    nodiplomname: 'Имя для диплома не указано',
                    catalog_info: 'Посмотреть как выглядит ваша компания в онлайн-каталоге',
                    catalog_submit: 'Перейти в каталог',
                    delete_confirm: 'Вы уверены что хотите удалить экспонента? Это действие необратимо!',
                    delete_success: 'Экспонент успешно удален',
                    delete_error: 'Ошибка удаления экспонента',
                    files: 'Файлы',
                    files_text: 'Вы можете загрузить до трех файлов в формате PDF с описанием своей продукции или услуг',
                    files_add: 'Загрузить файл',
                    files_edit: 'Редактировать',
                    files_delete: 'Удалить',
                    files_download: 'Скачать',
                    files_delete_confirm: 'Вы действительно хотите удалить файл? Это действие необратимо!',
                    activities: 'Расписание мероприятий',
                    noactivities: 'Мероприятия не указаны',
                    activity_confirm: 'Вы уверены что хотите удалить мероприятие? Это действие необратимо!',
                },
                exhibitoredit: {
                    title: 'Редактирование экспонента',
                    subtitle: 'Заполните поля ниже и нажмите кнопку "Сохранить"',
                    title_main: 'Редактирование общей информации',
                    title_texts: 'Редактирование информации',
                    title_links: 'Редактирование социальных сетей',
                    title_contacts: 'Редактирование контактов',
                    title_stickers: 'Редактирование стикеров',
                    title_categories: 'Редактирование категорий',
                    subtitle_categories: 'Выберите максимум <b>ТРИ</b> основные категории, по которым вы хотите, чтобы вас нашли посетители онлайн-каталога, и наиболее точно отражающие деятельность вашей компании.',
                    submit: 'Сохранить',
                    back: 'Вернуться без сохранения',
                    back2: 'Вернуться к экспоненту',
                    success: 'Изменения сохранены',
                    name_ru: 'Название на русском языке',
                    name_en: 'Название на английском языке',
                    name_hint: 'Укажите название, которое будет на вашем стенде и на плане зала выставки',
                    stand: 'Стенд',
                    stand_hint: 'Редактирование стенда доступно только администратору',
                    brand: 'Бренды',
                    brand_hint: 'Укажите бренды, которые вы производите или поставляете',
                    highlight: 'Категории "Обратите внимание"',
                    highlight_hint: 'Доступно для редактирования только администратору',
                    weight: 'Вес для сортировки',
                    weight_hint: 'Доступно для редактирования только администратору',
                    nohighlight: 'Не выделять экспонента',
                    nostickers: 'У мероприятия еще не определены стикеры',
                    nocategories: 'Экспонент еще не выбрал категории',
                    brief_ru: 'Кратко о компании на русском',
                    brief_en: 'Кратко о компании на английском',
                    brief_hint: 'Буквально в одном предложении расскажите главное о вашей компании.',
                    about_ru: 'Подробно о компании на русском',
                    about_en: 'Подробно о компании на английском',
                    about_hint: 'Что вы производите, дистрибутируете, какие услуги оказываете и на каких рынках. Ваши конкурентные преимущества и сильные стороны, в чем ваша уникальность?',
                    descr_ru: 'Зачем приходить на ваш стенд на русском',
                    descr_en: 'Зачем приходить на ваш стенд на английском',
                    descr_hint: 'Расскажите, что будет представлено на стенде - новинки, ноу-хау, макеты, образцы, лучшие продукты и услуги. Будут ли мастер-классы или презентации, особые условия для клиентов в дни выставки.',
                    country: 'Страна',
                    country_hint: 'Выберите страну из списка',
                    city_ru: 'Город / Населенный пункт на русском языке',
                    city_en: 'Город / Населенный пункт на английском языке',
                    phone: 'Телефон',
                    email: 'Электронная почта',
                    www: 'Сайт',
                    youtube: 'YouTube',
                    youtube_tpl: 'https://youtube.com/your_channel',
                    rutube: 'RuTube',
                    rutube_tpl: 'https://rutube.ru/your_channel',
                    vk: 'VK',
                    vk_tpl: 'https://vk.com/your_page',
                    telegram: 'Telegram',
                    telegram_tpl: 'https://t.me/your_channel',
                    yazen: 'Ya.Zen',
                    yazen_tpl: 'https://zen.yandex.ru/id/your_channel',
                    diplom_name: 'Название компании для диплома',
                    diplom_name_hint: 'Укажите название{{until}}. Иначе мы автоматически подтянем его из названия онлайн-каталога.',
                    diplom_name_hint_until: '  компании',
                    diplom_name_placeholder: 'Например: ООО «Вектор»',
                },
                progress: {
                    title: 'Статус профиля',
                    logo: 'Логотип',
                    brand: 'Бренд',
                    categories: 'Категории',
                    description: 'Описание',
                    contacts: 'Контакты',
                    links: 'Соцсети',
                },
                counter: {
                    title: 'Создание счетчика',
                    title_for: 'Создание счетчика для ',
                    start_date: 'Дата начала',
                    stop_date: 'Дата окончания',
                    start_value: 'Стартовое значение',
                    stop_value: 'Конечное значение',
                    delete_confirm: 'Вы уверены, что хотите удалить счетчик? Это действие необратимо!',
                },
                activityform: {
                    title_add: 'Добавление мероприятия',
                    title_edit: 'Редактирование мероприятия',
                    subtitle_add: 'Заполните поля и нажмите кнопку "Создать мероприятие"',
                    subtitle_edit: 'Отредактируйте поля и нажмите кнопку "Сохранить изменения"',
                    submit_add: 'Создать мероприятие',
                    submit_edit: 'Сохранить изменения',
                    date: "Дата проведения",
                    time: "Время проведения",
                    name_ru: 'Название по-русски',
                    name_en: 'Название по-английски',
                    name_ru_hint: 'Введите название на русском',
                    name_en_hint: 'Введите название на английском',
                    descr_ru: 'Описание по-русском',
                    descr_en: 'Описание по-английски',
                    descr_ru_hint: 'Введите описание на русском',
                    descr_en_hint: 'Введите описание на английском',
                    speaker_ru: 'Спикер по-русски',
                    speaker_en: 'Спикер по-английски',
                    speaker_ru_hint: 'Введите ФИО спикера на русском',
                    speaker_en_hint: 'Введите ФИО спикера на английском',
                },
                preset: {
                    type: 'Тип каталога',
                    lang: 'Язык интерфейса',
                    russian: 'Русский',
                    english: 'Английский',
                    exhibitors: 'Участники',
                    activities: 'Мероприятия',
                    dates: 'Даты мероприятий',
                    cntrs: 'Страны участников',
                    nourl: 'Необходимо указать URL в настройках мероприятия',
                    goto: 'Перейти по ссылке',
                    copy: 'Скопировать в клипбоард',
                    copied: 'Ссылка скопирована в клипбоард',
                },
                expodat: {
                    title: 'Экспорт в Expodat',
                    title_for: 'Экспорт в Expodat для ',
                    legend: 'Статус экспорта',
                    is_export: 'Экспорт включён',
                    api_url: 'API URL',
                    expo_id: 'Идентификатор выставки в Expodat',
                    hall_id: 'Идентификатор зала для мероприятий на стендах',
                    login: 'Логин в Expodat',
                    password: 'Пароль в Expodat',
                },
                country: {
                    title_list: 'Список стран',
                    title_edit: 'Редактирование страны',
                    name_ru: 'Название по-русски',
                    name_en: 'Название по-английски',
                },
            },
        },
        en: {
            translation: {
                about: {
                    title: 'About',
                    about: 'Exhibitor catalog cabinet.<br/>Developed by <a href="mailto:alex@molner.ru" target="_blank">Alexander Fedorov</a> commissioned by <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>.',
                },
                common: {
                    add: 'Add',
                    edit: 'Edit',
                    save: 'Save',
                    bind: 'Bind',
                    unbind: 'Unbind',
                    cancel: 'Cancel',
                    error: 'Error',
                    noerror: 'Ok',
                    remove: 'Remove',
                    loading: 'Loading...',
                    translating: 'Translating...',
                    translate_from_en: 'Translate from English',
                    translate_from_ru: 'Translate from Russian',
                    save_changes: 'Save',
                    save_success: 'Changes saved successfully',
                    fill_fields: 'Fill in the fields below and click "Save changes"',
                    back: 'Go back',
                },
                loader: {
                    title: 'Loading...',
                },
                error: {
                    error: 'Error',
                    noerror: 'Ok',
                    unknown: 'Error: Unknown Error',
                    api0: 'Error: Ok',
                    api1: 'Error: Access Denied',
                    api2: 'Error: Data Missing',
                    api3: 'Error: Bad Data',
                    api4: 'Error: Object Exists',
                    api5: 'Error: Not Found',
                    api6: 'Error: Database Error',
                    api7: 'Error: Server Error',
                    http0: 'Error: Network Error',
                    http400: 'Error: Bad Request',
                    http401: 'Error: Unauthorized',
                    http403: 'Error: Forbidden',
                    http404: 'Error: Not Found',
                    http413: 'Error: File upload size is too large',
                    http500: 'Error: Server Error',
                },
                a2e: { // admin to events
                    binds: 'Events',
                    nobinds: 'No events bound',
                    bindto: 'Available for binding',
                    nobindto: 'No events available to bind to',
                },
                e2e: { // exhibitor to exhibitors
                    add: 'Add exhibitor',
                    exhibitors: 'Managed exhibitors',
                    noexhibitors: 'No managed exhibitors',
                    show_actual: 'Show up-to-date',
                    show_archived: 'Show archived',
                },
                agent2event: {
                    binds: 'Events',
                    nobinds: 'No events bound',
                    bindto: 'Available for binding',
                    nobindto: 'No events available to bind to',
                    bind_update: 'Change',
                    bind_new: 'Bind',
                },
                pager: {
                    prev: 'Prev',
                    next: 'Next',
                    page: 'Page',
                    of: 'of',
                },
                logo: {
                    title: 'Logo',
                    type: 'Formats: jpg, png',
                    size: 'Maximum size: 2Mb',
                    dimension: 'Recommended dimention: 512x512',
                },
                file: {
                    title_add: 'File Upload',
                    title_edit: 'File Editing',
                    subtitle_add: 'Fill in the fields below and select a PDF file',
                    subtitle_edit: 'Edit the fields below and click the "Save changes" button',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    descr_ru: 'Description in Russian',
                    descr_en: 'Description in English',
                    file: 'File to upload',
                    file_hint: 'Files in PDF format no larger than 3 megabytes are allowed for uploading',
                    submit_add: 'Upload file',
                    submit_edit: 'Save changes',
                    back_add: 'Back without uploading',
                    back_edit: 'Back without saving',
                },
                user: {
                    name: 'Username',
                    email: 'Email',
                    password: 'Password',
                    role: 'User type',
                    all: 'All',
                    root: 'Superuser',
                    root_short: 'Super',
                    admin: 'Administrator',
                    admin_short: 'Admin',
                    exhibitor: 'Exhibitor',
                    exhibitor_short: 'Exhibitor',
                    agent: 'Agent',
                    agent_short: 'Agent',
                },
                menu: {
                    home: 'My exhibitions',
                    archive: 'Exhibition archive',
                    login: 'Log in to the cabinet',
                    restore: 'Forgot password',
                    newpass: 'Enter recovery code',
                    useradd: 'Add user',
                    userlist: 'Users',
                    eventadd: 'Add event',
                    eventlist: 'Events',
                    exhibitoradd: 'Add exhibitor',
                    exhibitorlist: 'Exhibitors',
                    countrylist: 'Countries',
                },
                home: {
                    title: 'Welcome',
                    subtitle_root: 'Choose what you want to work with',
                    subtitle_admin: 'Select the event you want to work with',
                    subtitle_agent_1: 'Enter maximum information about companies to <b>get 80%-300% more views</b> in the exhibition online-catalog!',
                    subtitle_agent_2: 'Tell everyone what\'s going on at stands and <b>convert views into real visitors</b>!',
                    subtitle_exhibitor1: 'Enter maximum information about your company - <b>get 80%-300% more views</b> in the exhibition online-catalog!',
                    subtitle_exhibitor2: 'Tell everyone what\'s going on at your stand and <b>convert views into real visitors</b>!',
                    users: 'Users',
                    events: 'Events',
                    exhibitors: 'Exhibitors',
                    noevents: 'No events to work with',
                    noexhibitors: 'No exhibitors to work with',
                    myevents: 'My exhibitions',
                    archive: 'Exhibition archive',
                    agent_can_add: 'Number of exhibitors available to add: ',
                },
                header: {
                    root: 'Superuser interface',
                    admin: 'Administrator interface',
                    agent: 'Agent interface',
                    exhibitor: 'Exhibitor interface',
                    unknown: 'Cabinet',
                },
                login: {
                    title: 'Login',
                    subtitle: 'Pleace enter your email and password',
                    email: 'Email',
                    password: 'Password',
                    submit: 'Login',
                    restore: 'Forgot password',
                },
                restore: {
                    title: 'Restoring access',
                    subtitle: 'Specify the email address to which the account is registered and click the "Restore access" button',
                    email: 'Email',
                    submit: 'Restore Access',
                    login: 'Log in to the cabinet',
                    code: 'Enter recovery code',
                    success: 'Please check your email. We have sent instructions to restore access to the cabinet there.',
                },
                newpass: {
                    title: 'Creating a new password',
                    subtitle: 'Specify your email address and the code from the email with instructions on restoring access.',
                    email: 'Email',
                    code: 'Recovery code',
                    submit: 'Create a new password',
                    login: 'Log in to the cabinet',
                    success: 'Please check your email. We have sent there a new password to access the cabinet.',
                },
                logout: {
                    title: 'logout',
                },
                userlist: {
                    title: 'Users',
                    placeholder: 'Start typing name or email',
                    found: 'Found users: ',
                    notfound: 'No users found for this query',
                    adduser: 'Add user',
                },
                useradd: {
                    title_: 'Adding user',
                    title_root: 'Adding superuser',
                    title_admin: 'Adding administrator',
                    title_exhibitor: 'Adding company',
                    title_agent: 'Adding agent',
                    subtitle_: 'Fill in the fields below',
                    subtitle_root: 'Fill in the fields below and click the "Add superuser" button',
                    subtitle_admin: 'Fill in the fields below and click the "Add administrator" button',
                    subtitle_exhibitor: 'Fill in the fields below and click the "Add company" button',
                    subtitle_agent: 'Fill in the fields below and click the "Add agent" button',
                    name_root: 'Superuser name',
                    name_admin: 'Administrator name',
                    name_exhibitor: 'Company name',
                    name_agent: 'Agent name',
                    event: 'Bind to exhibition',
                    event_hint: 'Select an exhibition from the list',
                    submit_: 'Add user',
                    submit_root: 'Add superuser',
                    submit_admin: 'Add administrator',
                    submit_exhibitor: 'Add company',
                    submit_agent: 'Add agent',
                    success_root: 'Superuser added',
                    success_admin: 'Administrator added',
                    success_exhibitor: 'Company added',
                    success_agent: 'Agent added',
                    password_hint: 'Generate password',
                    role: 'Select user type',
                    limit: 'Maximum number of exhibitors',
                },
                userview: {
                    title: 'User',
                    created: 'User successfully created',
                    updated: 'User successfully updated',
                    delete_confirm: 'Are you sure you want to delete the user? This action is irreversible!',
                    delete_success: 'User deleted successfully',
                    delete_error: 'Error deleting user',
                    convert2agent_confirm: 'Are you sure you want to convert the company to an agent?',
                    convert2exhibitor_confirm: 'Are you sure you want to convert the agent to a company?',
                    convert_success: 'User conversion was successful',
                    convert_error: 'User conversion error',
                },
                useredit: {
                    title_root: 'Edit superuser',
                    title_admin: 'Edit administrator',
                    title_exhibitor: 'Edit company',
                    title_agent: 'Edit agent',
                    subtitle: 'Edit the fields and click the "Save changes" button.',
                    name_root: 'Superuser name',
                    name_admin: 'Administrator name',
                    name_exhibitor: 'Company name',
                    name_agent: 'Agent name',
                    email: 'Email',
                    password: 'New password',
                    password_hint: 'If you do not need to change the password, leave the field blank. The new password must be at least 8 characters long.',
                    password_generate: 'Generate a new password',
                    submit: 'Save changes',
                    success: 'User updated successfully',
                    back: 'Return without saving',
                },
                eventlist: {
                    title: 'Events',
                    placeholder: 'Start typing name',
                    eventadd: 'Add event',
                    found: 'Found events: ',
                    notfound: 'No events found for this query',
                    actual: 'Current',
                    archived: 'Archived',
                },
                eventform: {
                    title_add: 'Adding an event',
                    title_edit: 'Editing an event',
                    subtitle_add: 'Fill in all fields and click "Add event"',
                    subtitle_edit: 'Fill in all fields and click "Save changes"',
                    submit_add: 'Add event',
                    submit_edit: 'Save changes',
                    success_add: 'Event added',
                    success_edit: 'Changes successfully saved',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    cat_main_ru: 'Name of main categories in Russian',
                    cat_main_en: 'Name of main categories in English',
                    cat_addon_ru: 'Name of additional categories in Russian',
                    cat_addon_en: 'Name of additional categories in English',
                    cat_admin_ru: 'Name of special categories in Russian',
                    cat_admin_en: 'Name of special categories in English',
                    catalog_url_ru: 'URL of the Russian version of the catalog',
                    catalog_url_en: 'URL of the English version of the catalog',
                    schedule_url_ru: 'URL of the Russian version of the schedule',
                    schedule_url_en: 'URL of the English version of the schedule',
                    back: 'Back to the event',
                    flags: 'Flags',
                    is_files_available: 'Allow exhibitors to upload files',
                    is_archived: 'Archived exhibition',
                    diplom_name_change_date: 'Date of diploma name change',
                    diplom_name_change_invalid_date: 'The date of diploma name change is in an invalid format',
                },
                eventview: {
                    title: 'Event',
                    created: 'Event successfully created',
                    updated: 'Event successfully updated',
                    admins: 'Administrators',
                    binds: 'Administrators',
                    nobinds: 'The event has no administrators',
                    bindto: 'Available for binding',
                    nobindto: 'There are no administrators available for binding',
                    categories: 'Categories',
                    catmain: 'Main categories:',
                    nocatmain: 'No main categories defined',
                    cataddon: 'Additional categories:',
                    nocataddon: 'No additional categories defined',
                    catadmin: 'Special categories:',
                    nocatadmin: 'No special categories defined',
                    export_catalog: 'Exhibitors export',
                    export_events: 'Events export',
                    files: 'Files',
                    files_available: 'Exhibitors can upload files',
                    files_unavailable: 'Exhibitors are not allowed to upload files',
                    stickers: 'Stickers',
                    nostickers: 'No stickers defined',
                    nofolder: 'Other',
                    counter: 'Counter',
                    nocounter: 'The counter is not defined',
                    dates: 'Dates',
                    nodates: 'No dates have been set',
                    preset: 'Link constructor',
                    expodat: 'Export to Expodat',
                },
                category: {
                    addtitle: 'Adding a category',
                    addsubtitle: 'Category will be added for the exhibition ',
                    edittitle: 'Category editing',
                    editsubtitle: 'Editing a category for an exhibition ',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    type: 'Category type',
                    folder: 'Add category to folder',
                    folder_hint: 'Select folder',
                    is_folder: 'Folder',
                    is_folder_label: 'Category is a folder',
                    priority: 'Priority',
                    main: 'Main',
                    addon: 'Additional',
                    admin: 'Special',
                    admin_hint: 'Checkable by admin only',
                    addsubmit: 'Add category',
                    addsuccess: 'Category added',
                    editsubmit: 'Save changes',
                    editsuccess: 'Changes saved',
                    delete: 'Delete category',
                    delete_confirm: 'Are you sure you want to delete the category? This action is irreversible!',
                    back: 'Back to the exhibition',
                },
                sticker: {
                    addtitle: 'Adding a sticker',
                    addsubtitle: 'Sticker will be added for the exhibition ',
                    edittitle: 'Sticker editing',
                    editsubtitle: 'Editing a sticker for an exhibition ',
                    text_ru: 'Text in Russian',
                    text_en: 'Text in English',
                    color: 'Text color',
                    background: 'Background color',
                    priority: 'Priority',
                    addsubmit: 'Add sticker',
                    addsuccess: 'Sticker added',
                    editsubmit: 'Save changes',
                    editsuccess: 'Changes saved',
                    delete: 'Delete sticker',
                    delete_confirm: 'Are you sure you want to delete the sticker? This action is irreversible!',
                    back: 'Back to the exhibition',
                },
                exhibitorlist: {
                    title: 'Exhibitors',
                    placeholder: 'Start typing name',
                    found: 'Found exhibitors: ',
                    notfound: 'No exhibitors found for this query',
                },
                exhibitoradd: {
                    title: 'Adding an exhibitor',
                    subtitle1exhibitor: 'To add an exhibitor for company ',
                    subtitle1agent: 'To add an exhibitor for agent ',
                    subtitle2: ' fill in the fields below and click "Add exhibitor"',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    event: 'Exhibition',
                    copy: 'Copy main fields from',
                    event_hint: 'Select event from the list',
                    exhibitor_hint: 'Select exhibitor from the list',
                    admin: 'Manager',
                    admin_hint: 'Select a manager from the list',
                    submit: 'Add exhibitor',
                    success: 'Exhibitor added',
                    baduser: 'Error: Invalid company ID. You probably came to this page through the wrong link.',
                    weight: 'Weight to sort',
                },
                exhibitorview: {
                    title: 'Exhibitor',
                    created: 'Exhibitor successfully created',
                    updated: 'Information saved successfully',
                    stand: 'Stand',
                    nostand: 'Stand is not specified',
                    brand: 'Brands',
                    nobrand: 'Brands are not specified',
                    brief: 'Briefly about the company',
                    nobrief: 'No brief information about the company',
                    about: 'Details about the company',
                    noabout: 'No detailed information about the company',
                    descr: 'Why come to your stand',
                    nodescr: 'There is no description of the stand contents',
                    contacts: 'Contacts',
                    nocontacts: 'No contact information',
                    links: 'Social networks',
                    nolinks: 'Links are not specified',
                    stickers: 'Stickers',
                    nostickers: 'Please contact your project manager to order a sticker.',
                    stickers_tt: 'A sticker is a bright visual element with text that is placed on top of a company card in the catalog. It will help make your company stand out from other participants.',
                    categories: 'Categories',
                    nocategories: 'Categories are not specified',
                    diplomname: 'Diploma name',
                    nodiplomname: 'No diploma name specified',
                    catalog_info: 'See what your company looks like in the online catalog',
                    catalog_submit: 'Go to catalog',
                    delete_confirm: 'Are you sure you want to delete the exhibitor? This action is irreversible!',
                    delete_success: 'Exhibitor deleted successfully',
                    delete_error: 'Error deleting exhibitor',
                    files: 'Files',
                    files_text: 'You can upload up to three PDF files describing your products or services',
                    files_add: 'Upload file',
                    files_edit: 'Edit',
                    files_delete: 'Delete',
                    files_download: 'Download',
                    files_delete_confirm: 'Are you sure you want to delete the file? This action is irreversible!',
                    activities: 'Schedule of activities',
                    noactivities: 'No activities specified',
                    activity_confirm: 'Are you sure you want to delete the activity? This action is irreversible!',
                },
                exhibitoredit: {
                    title: 'Exhibitor editing',
                    subtitle: 'Fill in the fields below and click "Save"',
                    title_main: 'Edit basic information',
                    title_texts: 'Edit information',
                    title_links: 'Edit social networks',
                    title_contacts: 'Edit contacts',
                    title_stickers: 'Edit stickers',
                    title_categories: 'Edit categories',
                    subtitle_categories: 'Select a maximum of <b>THREE</b> main categories for which you want to be found by visitors to the online catalog, and most accurately reflect the activities of your company.',
                    submit: 'Save',
                    back: 'Return without saving',
                    back2: 'Back to exponent',
                    success: 'Changes saved',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    name_hint: 'Specify the name that will be on your stand and on the floor plan of the exhibition hall',
                    stand: 'Stand',
                    stand_hint: 'Stand editing is available only to the administrator',
                    brand: 'Brands',
                    brand_hint: 'Specify the brands you manufacture or supply',
                    highlight: 'Categories "Pay Attention"',
                    highlight_hint: 'Editable only by the administrator',
                    weight: 'Weight to sort',
                    weight_hint: 'Editable only by the administrator',
                    nohighlight: 'Don\'t highlight exhibitor',
                    nostickers: 'The event has no stickers defined yet',
                    nocategories: 'The exhibitor hasn\'t selected categories yet',
                    brief_ru: 'Briefly about the company in Russian',
                    brief_en: 'Briefly about the company in English',
                    brief_hint: 'Describe in one sentence the main thing about your company.',
                    about_ru: 'Details about the company in Russian',
                    about_en: 'Details about the company in English',
                    about_hint: 'What do you produce, distribute, what services do you provide and in which markets. Your competitive advantages and strengths, what is your uniqueness?',
                    descr_ru: 'Why come to your stand in Russian',
                    descr_en: 'Why come to your stand in English',
                    descr_hint: 'Tell us what will be presented at the stand - novelties, know-how, layouts, samples, the best products and services. Whether there will be master classes or presentations, special conditions for clients during the exhibition.',
                    country: 'Country',
                    country_hint: 'Select a country from the list',
                    city_ru: 'City / Locality in Russian',
                    city_en: 'City / Locality in English',
                    phone: 'Phone',
                    email: 'Email',
                    www: 'Website',
                    youtube: 'YouTube',
                    youtube_tpl: 'https://youtube.com/your_channel',
                    rutube: 'RuTube',
                    rutube_tpl: 'https://rutube.ru/your_channel',
                    vk: 'VK',
                    vk_tpl: 'https://vk.com/your_page',
                    telegram: 'Telegram',
                    telegram_tpl: 'https://t.me/your_channel',
                    yazen: 'Ya.Zen',
                    yazen_tpl: 'https://zen.yandex.ru/id/your_channel',
                    diplom_name: 'Company name for certificate',
                    diplom_name_hint: 'Enter{{until}}. Otherwise, we\'ll auto-fill from the exhibitor-directory.',
                    diplom_name_hint_until: ' company name',
                    diplom_name_placeholder: 'E.g., Vector LLC',
                },
                progress: {
                    title: 'Profile status',
                    logo: 'Logo',
                    brand: 'Brand',
                    categories: 'Categories',
                    description: 'Description',
                    contacts: 'Contacts',
                    links: 'Social',
                },
                counter: {
                    title: 'Creating a counter',
                    title_for: 'Creating a counter for ',
                    start_date: 'Start date',
                    stop_date: 'End date',
                    start_value: 'Starting value',
                    stop_value: 'Final value',
                    delete_confirm: 'Are you sure you want to delete the counter? This action is irreversible!',
                },
                activityform: {
                    title_add: 'Add activity',
                    title_edit: 'Activity editing',
                    subtitle_add: 'Fill in the fields and click the "Create activity" button',
                    subtitle_edit: 'Edit the fields and click the "Save changes" button',
                    submit_add: 'Create activity',
                    submit_edit: 'Save changes',
                    date: "Activity date",
                    time: "Activity time",
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                    name_ru_hint: 'Enter name in Russian',
                    name_en_hint: 'Enter name in English',
                    descr_ru: 'Description in Russian',
                    descr_en: 'Description in English',
                    descr_ru_hint: 'Enter description in Russian',
                    descr_en_hint: 'Enter description in English',
                    speaker_ru: 'Speaker in Russian',
                    speaker_en: 'Speaker in English',
                    speaker_ru_hint: 'Enter speaker\'s full name in Russian',
                    speaker_en_hint: 'Enter speaker\'s full name in English',
                },
                preset: {
                    type: 'Directory type',
                    lang: 'Interface language',
                    russian: 'Russian',
                    english: 'English',
                    exhibitors: 'Exhibitors',
                    activities: 'Activities',
                    dates: 'Event dates',
                    cntrs: 'Countries of exhibitors',
                    nourl: 'You must specify the URL in the event settings',
                    goto: 'Go to link',
                    copy: 'Copy to clipboard',
                    copied: 'Link copied to clipboard',
                },
                expodat: {
                    title: 'Export to Expodat',
                    title_for: 'Export to Expodat for ',
                    legend: 'Export status',
                    is_export: 'Export is active',
                    api_url: 'API URL',
                    expo_id: 'Expo ID in Expodat',
                    hall_id: 'Hall ID for exhibitor events',
                    login: 'Login for Expodat',
                    password: 'Password for Expodat',
                },
                country: {
                    title_list: 'List of countries',
                    title_edit: 'Country editing',
                    name_ru: 'Name in Russian',
                    name_en: 'Name in English',
                },
            },
        },
    },
});

export default i18n;
